/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update a document folder (rename, move, change color).
 * @export
 * @interface UpdateDocumentFolderRequest
 */
export interface UpdateDocumentFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentFolderRequest
     */
    name?: string;
    /**
     * New parent folder ID. Null to move to root.
     * @type {number}
     * @memberof UpdateDocumentFolderRequest
     */
    parentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentFolderRequest
     */
    color?: string | null;
}

/**
 * Check if a given object implements the UpdateDocumentFolderRequest interface.
 */
export function instanceOfUpdateDocumentFolderRequest(value: object): value is UpdateDocumentFolderRequest {
    return true;
}

export function UpdateDocumentFolderRequestFromJSON(json: any): UpdateDocumentFolderRequest {
    return UpdateDocumentFolderRequestFromJSONTyped(json, false);
}

export function UpdateDocumentFolderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDocumentFolderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function UpdateDocumentFolderRequestToJSON(json: any): UpdateDocumentFolderRequest {
    return UpdateDocumentFolderRequestToJSONTyped(json, false);
}

export function UpdateDocumentFolderRequestToJSONTyped(value?: UpdateDocumentFolderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'parentId': value['parentId'],
        'color': value['color'],
    };
}

